/* global google */
/* eslint-disable import/prefer-default-export */
const googleOauth = document.createElement('script')
googleOauth.setAttribute('src', 'https://accounts.google.com/gsi/client')
document.head.appendChild(googleOauth)

export function initClientGoogle(login, clientId) {
  // eslint-disable-next-line no-unused-vars, no-undef
  const client = google.accounts.oauth2.initCodeClient({
    client_id: clientId,
    scope: 'https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/gmail.readonly',
    ux_mode: 'popup',
    callback: tokenResponse => {
      login(tokenResponse)
    },
  }).requestCode()
}

// Função para login OAuth2 padrão do Google (obter JWT do usuário)
export function initGoogleOAuth2Login(callback, clientId) {
  if (!window.google || !window.google.accounts || !window.google.accounts.id) {
    const script = document.createElement('script')
    script.setAttribute('src', 'https://accounts.google.com/gsi/client')
    script.onload = () => {
      google.accounts.id.initialize({
        client_id: clientId,
        callback: response => {
          callback(response)
        },
      })
      google.accounts.id.prompt()
    }
    document.head.appendChild(script)
  } else {
    google.accounts.id.initialize({
      client_id: clientId,
      callback: response => {
        callback(response)
      },
    })
    google.accounts.id.prompt()
  }
}
